import './src/theme/fonts.css'
import './src/theme/material-symbols.css'
require('katex/dist/katex.min.css')

/*
 * The old browser entry registered the DeckDeckGo code component on every
 * route and bundled two font packages no live style still referenced. Keep
 * the self-hosted editorial fonts above, and only fetch/register the sizeable
 * syntax-highlighter loader on an article that actually contains one.
 */
let highlightLoader;

export const onRouteUpdate = () => {
    if (typeof document === 'undefined' || !document.querySelector('deckgo-highlight-code')) return;
    if (!highlightLoader) {
        highlightLoader = import('@deckdeckgo/highlight-code/dist/loader')
            .then(({defineCustomElements}) => defineCustomElements());
    }
    return highlightLoader;
};